import fetch from './http';
/**
 * 获取店铺信息
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
export const getStore = (params, headers) => {
    return fetch.fetchGet('api/store/v1/store/get', params, headers);
  };